function mtcClearCart(btn) {
  btn.disabled = true;
  fetch('/cart/clear.js', { method: 'POST' })
    .then(function () {
      window.location.reload();
    })
    .catch(function () {
      btn.disabled = false;
    });
}